import { isInvalidAuth } from "@/lib/utils";

export default {
  methods: {
    notification(title, message, type) {
      this.$notify({
        title,
        message,
        customClass: type,
        duration: 3500
      });
    },
    handleErrors(response) {
      const codes = {
        ACCESS_DENIED: "Access Denied",
        INVALID_CRED: "Invalid Credentials",
        NO_AUTH: "Unauthorized",
        INVALID_INPUT: "Invalid Input",
        ROUTE_NOT_FOUND: "Data Error"
      };

      if (response.data) {
        let errorData = Array.isArray(response.data)
          ? response.data[0]
          : response.data;

        let messages = "";
        for (let message in errorData) {
          messages += `${messages}\n${errorData[message][0]}`;
        }

        this.notification(
          (response.code && codes[response.code]) || "Error",
          messages,
          "danger"
        );
      } else {
        if (isInvalidAuth(response.code)) {
          // this.$router.push({ name: "login" });
        }
        this.notification(
          (response.code && codes[response.code]) || "Error",
          response.message,
          "danger"
        );
      }
    }
  }
};
